/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Contact } from '../../../core/models/common/Contact';
import { License } from '../../../core/models/common/License';
import { OasInfo } from '../../models/OasInfo';
import { Oas30Contact } from './Oas30Contact';
import { Document } from '../../../core/models/Document';
import { Node } from '../../../core/models/Node';
import { Oas30License } from './Oas30License';

/**
 * Constructor.
 * @class
 * @extends OasInfo
 * @author eric.wittmann@gmail.com
 */
export class Oas30Info extends OasInfo {
    public constructor() {
        super();
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Info#createContact()
     * @return {Contact}
     */
    public createContact() : Contact {
        let contact : Contact = new Oas30Contact();
        contact._ownerDocument = this.ownerDocument();
        contact._parent = this;
        return contact;
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Info#createLicense()
     * @return {License}
     */
    public createLicense() : License {
        let license : License = new Oas30License();
        license._ownerDocument = this.ownerDocument();
        license._parent = this;
        return license;
    }
}
Oas30Info["__class"] = "io.apicurio.datamodels.openapi.v3.models.Oas30Info";
Oas30Info["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable"];




